import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class UiComponentsService {
  updateDropdownSearchComponentList$: Subject<any> = new Subject();
}
